<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>
  <!-- ciderIngredientType -->

  <mat-form-field *ngIf="getCtrl('ciderIngredientType')">
    <app-easy-select
      formControlName="ciderIngredientType"
      [label]="TITLE + 'INGREDIENT_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.INGREDIENT_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        ciderIngredientType | toSelectOption: 'PRODUCTS.INGREDIENT_TYPE.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- fruitWineIngredientType -->

  <mat-form-field *ngIf="getCtrl('fruitWineIngredientType')">
    <app-easy-select
      formControlName="fruitWineIngredientType"
      [label]="TITLE + 'INGREDIENT_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.INGREDIENT_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        fruitWineIngredientType | toSelectOption: 'PRODUCTS.INGREDIENT_TYPE.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- vermouthType -->

  <mat-form-field *ngIf="getCtrl('vermouthType')">
    <app-easy-select
      formControlName="vermouthType"
      [label]="TITLE + 'VERMOUTH_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.VERMOUTH_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="vermouthType | toSelectOption: 'PRODUCTS.VERMOUTH_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
